import { render, staticRenderFns } from "./AboutTechBlock.vue?vue&type=template&id=3d3202b0"
import script from "./AboutTechBlock.vue?vue&type=script&lang=js"
export * from "./AboutTechBlock.vue?vue&type=script&lang=js"
import style0 from "./AboutTechBlock.vue?vue&type=style&index=0&id=3d3202b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports